import * as room from './room'



const home={
    room
}

export default home;